var exports = {
  "DD": "RecoverAccountPage.module__title___NnZXVW",
  "h_": "RecoverAccountPage.module__description___NnZXVW",
  "Zd": "RecoverAccountPage.module__form___NnZXVW",
  "qr": "RecoverAccountPage.module__footer___NnZXVW",
  "zc": "RecoverAccountPage.module__formError___NnZXVW",
  "iS": "RecoverAccountPage.module__keyInput___NnZXVW",
  "aK": "RecoverAccountPage.module__hint___NnZXVW",
  "nf": "RecoverAccountPage.module__link___NnZXVW",
};

module.exports = exports;
